<template>
  <v-container>
    <div class="my-5">
      <v-img src="/img/icon/commentary.png" width="64" cover style="margin: auto;" />
      <div class="page-title text-center my-2">
        Event / unity1week / <span class="page-title-japanese ml-3">つたえる</span>
      </div>
      <div class="page-abstract text-center my-4">
        最近、誰かに思いを伝えましたか…？<br>
        ゲームであなたの思いを伝えませんか…？
      </div>
    </div>

    <div class="my-5">
      <h2 class="u1w-section-title">イベント概要！</h2>
      <div class="u1w-section-contents mt-4 mr-3">
        <v-img src="/img/unity2week-thumbnail.png" style="border: 1px solid #1b1e21;" />
        <br />
          <div style="font-size: 150%"><span style="font-size: 130%">ぱふもどき</span>が<span
                style="color: #ff00ff"><span style="font-size: 130%">心身を削り</span></span>ながら<span
                style="font-size: 130%"><span style="color: #ff8c00"><s>たったの1週間</s>今回は2週間！</span></span>でイベント期間中に<span
                style="font-size: 130%"><span style="color: #1464b3">投稿された全てのゲーム</span></span>(※1)の<span
                style="font-size: 130%"><span style="color: #286f2c">攻略</span></span>に<span
                style="font-size: 130%"><span style="color: #ff0000">挑戦</span></span>するイベントです！
            <span style="font-size: 70%; color: #696969">(※1)遅れて投稿されたゲームも放送期間内であれば含む</span>
          </div>
        <p>
          <br>
          「1weekに参加したけど遊ばれないのでは...」<br>
          「プレイヤーの生の声が聴きたい！」<br>
          「遊ばれない恐怖で投稿できない...」<br>
          「ゲームがうまい人のプレイを見てみたい！」<br>
          「プレイはせずにラジオ感覚で作品を見たい！」<br>
        </p>
        <p>
          <br>
          そんな方々におススメのイベントとなっています！
        </p>
      </div>
    </div>

    <div class="mb-5">
      <h2 class="u1w-section-title">放送予定日時</h2>
      <div class="datetime mt-4 mr-3">
        <table>
        <tr>
            <th>3/27 (月)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>3/28 (火)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>3/29 (水)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>3/30 (木)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>3/31 (金)</th>
            <td>20:00 ~ 25:00</td>
        </tr>
        <tr>
            <th>4/1 (土)</th>
            <td>13:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>4/2 (日)</th>
            <td>13:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>4/3 (月)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>4/4 (火)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>4/5 (水)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>4/6 (木)</th>
            <td>20:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>4/7 (金)</th>
            <td>20:00 ~ 25:00</td>
        </tr>
        <tr>
            <th>4/8 (土)</th>
            <td>13:00 ~ 24:00</td>
        </tr>
        <tr>
            <th>4/9 (日)</th>
            <td>13:00 ~ 24:00</td>
        </tr>
      </table>
        ※ 時間変更が生じる場合があります。変更は <a href="https://twitter.com/PafuOfDuck">Twitter</a> でお知らせします。
      </div>
    </div>

    <div class="mb-5">
      <h2 class="u1w-section-title">放送URL</h2>
      <p class="mt-4">
        <a href="https://www.youtube.com/c/PAFUsGAME/live">”ぱふちゃんねる”の生放送ページ</a>
      </p>
      <p>
        是非、チャンネル登録して下さい！見逃し防止になります！
      </p>
    </div>

    <div class="container-fluid mb-5">
      <h2 class="u1w-section-title"><span class="icon"><i class="fas fa-hand-holding-heart"></i></span>おねがい</h2>
      <div class="u1w-section-contents mt-4 mr-3">
        放送当日の放送開始前にYoutubeの放送URLをTwitterでお知らせします。<br>
        放送期間中、お手数ですがTwitterのフォローをお願いします！<br><br>
        <a href="https://twitter.com/intent/follow?screen_name=PafuOfDuck" target="_blank">
          <i class="fab fa-twitter-square"></i>
          Twitterをフォローする
        </a>
      </div>
    </div>

    <div class="mb-5">
      <h2 class="u1w-section-title"><span class="icon"><i class="fas fa-question-circle"></i></span>Q & A</h2>
      <div class="u1w-section-contents mt-4 mr-3">
        <Unity1weekQA></Unity1weekQA>
      </div>
    </div>

    <div class="mb-5">
      <h2 class="u1w-section-title">アーカイブ & プレイリスト （順次更新）</h2>
      <div class="u1w-section-contents mt-4 mr-3">
        <div class="my-3">
          更新待ち…
        </div>
      </div>
    </div>

  </v-container>
</template>
  
<script>
import Unity1weekQA from '../components/Unity1weekQA.vue';
export default {
  name: 'HelloWorld',
  components: {
    Unity1weekQA
  },
  props: {
    theme: String
  }
}
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.page-title {
    color: #807866;
    font-size: 24px;
}

.page-title-japanese {
    color: #1b1e21;
    font-size: 60px;
}

.u1w-section-contents img {
    height: auto;
    width: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
}

.u1w-section-title {
    border-bottom: solid 3px #fd7e14;
}

/* 日付の表 */

.datetime table {
  width: 100%;
  border-collapse: collapse;
}

.datetime table tr{
  border-bottom: solid 2px white;
}

.datetime table tr:last-child{
  border-bottom: none;
}

.datetime table th{
  position: relative;
  text-align: left;
  width: 30%;
  background-color: #52c2d0;
  color: white;
  text-align: center;
  padding: 10px 0;
}

.datetime table th:after{
  display: block;
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  top:calc(50% - 10px);
  right:-10px;
  border-left: 10px solid #52c2d0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.datetime table td{
  text-align: left;
  width: 70%;
  text-align: center;
  background-color: #eee;
  padding: 10px 0;
}


</style>